export type JobStatus = 'PENDING' | 'IN_PROGRESS' | 'FAILED' | 'SUCCESS' | 'CANCELLED';

export const isJobRunning = (job: { meta: { '@status': JobStatus } }) => {
	return job.meta['@status'] === 'PENDING' || job.meta['@status'] === 'IN_PROGRESS';
};

export const getJobRefetchInterval = (job: { meta: { '@status': JobStatus } } | null | undefined) => {
	if (job && isJobRunning(job)) {
		return 2500;
	}
	return false;
};
